export default class SearchForm {

    constructor() {
        this.searchContainer = document.querySelector('.search-container');
        this.mobileHeaderContainer = document.querySelector('header .mobile-header > div');
        this.mobileSearchContainer = false;
        this.addMobileSearch();


        this.searchButton = document.querySelector('.search-toggler');
        this.mobileSearchButton = document.querySelector('.mobile-header .search-toggler');
        this.searchForm = document.querySelector('form.header-search');
        this.searchAgainButton = document.querySelector('.search-again a');
    }

    init() {
        if(this.searchButton || this.searchAgainButton) {
            this.openSearchForm();
            this.closeSearchForm();
        }
    }

    addMobileSearch() {
        if(this.mobileHeaderContainer && this.searchContainer) {
            this.mobileHeaderContainer.innerHTML += this.searchContainer.outerHTML;
            this.mobileSearchContainer = document.querySelector('.mobile-header .search-container');
        }
    }

    openSearchForm() {
        const that = this;
        let searchButtonIconSrc = that.searchButton.children[0].getAttribute("src");
        let searchButtonIconSrcSet = that.searchButton.children[0].getAttribute("srcset");
        this.searchButton.addEventListener('click', (e) => { this.openSearchHandler(that)});

        if(this.mobileSearchButton) {
            this.mobileSearchButton.addEventListener('click', (e) => { this.openSearchHandler(that)});
        }

        if ( this.searchAgainButton ) {
            this.searchAgainButton.addEventListener('click', (e) => { this.openSearchHandler(that)});
        }
    }

    openSearchHandler(that){

        that.searchContainer.classList.toggle('search-toggled');
        if(that.mobileSearchContainer) {
            that.mobileSearchContainer.classList.toggle('search-toggled');
        }
        document.body.classList.toggle('has-overlay');
        that.setSearchbarHeight();
        that.scrollToTop();
    }

    closeSearchForm() {
        let body = document.body,
            that = this;
        body.addEventListener("click",(e)=>{
            if(body.classList.contains('has-overlay') && !e.target.matches("header") && !e.target.matches("header *")
                && !e.target.matches('.search-again') && !e.target.matches('.search-again *')){
                document.body.classList.toggle('has-overlay');
                that.searchContainer.classList.toggle('search-toggled');
                if(that.mobileSearchContainer) {
                    that.mobileSearchContainer.classList.toggle('search-toggled');
                }
            }
        })
    }

    setSearchbarHeight() {
        let height = document.querySelector('header.wp-block-template-part').offsetHeight;
        this.searchContainer.style.height = `${height}px`;
        if(this.mobileSearchContainer) {
            this.mobileSearchContainer.style.height = `${height}px`;
        }
    }

    scrollToTop() {
        let elem = document.scrollingElement || document.documentElement,
            from = window.scrollY,
            time = 100,
            prop = true,
            to = 0;
        if (!elem) {
            return;
        }
        var start = new Date().getTime(),
            timer = setInterval(function() {
                var step = Math.min(1, (new Date().getTime() - start) / time);
                if (prop) {
                    elem['scrollTop'] = (from + step * (to - from));
                } else {
                    elem.style['scrollTop'] = (from + step * (to - from));
                }
                if (step === 1) {
                    clearInterval(timer);
                }
            }, 25);
        if (prop) {
            elem['scrollTop'] = from;
        } else {
            elem.style['scrollTop'] = from;
        }
    }
}